import { Helper, Foundation } from 'src/_Shared/global'
import { initializeApp } from 'firebase/app'
import { getAnalytics, logEvent } from 'firebase/analytics'
import {
  ReCaptchaV3Provider,
  getToken,
  initializeAppCheck,
} from 'firebase/app-check'

export namespace FirebaseAnalytics {
  //==============================
  //#region Setup
  //==============================
  export async function getConfig() {
    //return an empty config just in case
    return {
      apiKey: '',
      authDomain: '',
      projectId: '',
      storageBucket: '',
      messagingSenderId: '',
      appId: '',
      measurementId: '',
    }
  }

  //==============================
  //#region Trigger Event
  //==============================
  export async function trigger(event: string, payload?: any) {
    //Don't Initialize Firebase
    return
  }

  //==============================
  //#region Configure App Check
  //==============================
  export async function configureAppCheck() {
    try {
      const config = await getConfig()
      const app = initializeApp(config)

      //Initialize app check for API security
      const appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(
          '6LcFe64nAAAAAMk7eLizEFsTdJTUABNHfCmUGjuR',
        ),
        isTokenAutoRefreshEnabled: true,
      })
      const appCheckTokenResponse = await getToken(appCheck, false)

      localStorage.setItem('appCheckToken', appCheckTokenResponse.token)
    } catch (error) {
      //Redirecting to home was the default behavior previously.
      window.location.href = ''
    }
  }
}
